export default __webpack_public_path__ + "static/media/Facebook-big.70ce5f83.svg";